import { api } from "../../../../services/api.js";
import { BASE } from "../../../../services/simuladoresConteudoApi.js";
import React, { useState, useEffect } from "react";
import {
  BRAND_DARK,
  BTN_GHOST,
  BTN_PRIMARY,
  BTN_SECONDARY,
  BUTTON_RESET,
  CARD,
  INPUT,
  LABEL,
} from "../../../../styles";
import { clone, fileToDataUrl, uuid } from "../../../../shared/utils";
import { sourceImage } from "../../../../utils/source-image";
import { Modal } from "../../../../components/Modal";
import { AdminCourseManager } from "./Course";
import { ErrorPanel } from "./Error";
import {
  fetchSimuladorCategorias,
  fetchSimuladorCursosPaginated,
  fetchSimuladoresConteudoErros,
  fetchSimuladoresConteudoInativos,
  reorderSimuladorCurso,
  saveSimuladoresConteudoErrors,
} from "../../../../services/simuladoresConteudoApi";
export default function SimuladoresConteudoAdminModule(props) {
  let conteudos = props.conteudos;
  let setConteudos = props.setConteudos;
  let addConteudoCategoria = props.addConteudoCategoria;
  let updateSimuladorCategoria = props.updateSimuladorCategoria;
  let addConteudoCurso = props.addConteudoCurso;
  let updateConteudoCurso = props.updateConteudoCurso;
  let removeConteudoCurso = props.removeConteudoCurso;
  let restoreConteudoCurso = props.restoreConteudoCurso;
  let addConteudoModulo = props.addConteudoModulo;
  let updateConteudoModulo = props.updateConteudoModulo;
  let removeConteudoModulo = props.removeConteudoModulo;
  let restoreConteudoModulo = props.restoreConteudoModulo;
  let addConteudoAula = props.addConteudoAula;
  let updateConteudoAula = props.updateConteudoAula;
  let removeConteudoAula = props.removeConteudoAula;
  let restoreConteudoAula = props.restoreConteudoAula;
  let removeConteudoCategoria = props.removeConteudoCategoria;
  let restoreSimuladorCategoria = props.restoreSimuladorCategoria;
  let showFlash = props.showFlash;
  const [aba, setAba] = useState("cursos");
  const [categoriaOpen, setCategoriaOpen] = useState(false);
  const [categoriaEditando, setCategoriaEditando] = useState(null);
  const [cursoOpen, setCursoOpen] = useState(false);
  const [cursoSelecionado, setCursoSelecionado] = useState(null);
  const [categoriaForm, setCategoriaForm] = useState({
    nome: "",
    capa: null,
  });
  const [cursoForm, setCursoForm] = useState({
    nome: "",
    sigla: "",
    cat_id: "",
    descricao: "",
  });
  const [inativosLoading, setInativosLoading] = useState(false);
  const [inativos, setInativos] = useState({
    categorias: [],
    cursos: [],
    modulos: [],
    aulas: [],
  });
  const [destinoCursoPorModulo, setDestinoCursoPorModulo] = useState({});
  const [destinoModuloPorAula, setDestinoModuloPorAula] = useState({});
  const [filtroInativosTexto, setFiltroInativosTexto] = useState("");
  const [filtroInativosTipo, setFiltroInativosTipo] = useState("todos");
  const [cursoDragId, setCursoDragId] = useState(null);
  const [cursoDragOverId, setCursoDragOverId] = useState(null);
  const [cursosLoading, setCursosLoading] = useState(false);
  const [todosOsCursos, setTodosOsCursos] = useState([]);
  const [cursosTotal, setCursosTotal] = useState(0);
  const [cursosCarregados, setCursosCarregados] = useState(false);
  const [localCategorias, setLocalCategorias] = useState([]);
  const [catPage, setCatPage] = useState(1);
  const [categoriasCarregadas, setCategoriasCarregadas] = useState(false);
  const [problemas, setProblemas] = useState([]);
  const [problemasLoading, setProblemasLoading] = useState(false);
  const parseOrdemCurso = (curso) => {
    const ordemNumero = Number(curso?.ordem);
    return Number.isFinite(ordemNumero) ? ordemNumero : 0;
  };
  const ordenarCursos = (lista = []) =>
    [...lista].sort((a, b) => {
      const ordemA = parseOrdemCurso(a);
      const ordemB = parseOrdemCurso(b);

      if (ordemA !== ordemB) {
        return ordemA - ordemB;
      }

      return String(a?.nome || "").localeCompare(
        String(b?.nome || ""),
        "pt-BR",
      );
    });
  const reordenarCursosCategoria = async (
    resultado,
    cursoOrigemId,
    cursoDestinoId,
    cursosCategoriaOrdenados,
  ) => {
    if (!cursoOrigemId || !cursoDestinoId || cursoOrigemId === cursoDestinoId)
      return;
    const origemIndex = cursosCategoriaOrdenados.findIndex(
      (curso) => curso.id === cursoOrigemId,
    );
    const destinoIndex = cursosCategoriaOrdenados.findIndex(
      (curso) => curso.id === cursoDestinoId,
    );
    if (!(origemIndex < 0 || destinoIndex < 0))
      try {
        await reorderSimuladorCurso({
          sourceId: cursoOrigemId,
          targetId: cursoDestinoId,
        });
        const reordenados = [...cursosCategoriaOrdenados];
        const spliceResult = reordenados.splice(origemIndex, 1);
        const [cursoMovido] = spliceResult;
        reordenados.splice(destinoIndex, 0, cursoMovido);
        const novaOrdemPorId = new Map(
          reordenados.map((curso, index) => [curso.id, index + 1]),
        );
        setTodosOsCursos((prev) =>
          prev.map((prevId) =>
            novaOrdemPorId.has(prevId.id)
              ? {
                  ...prevId,
                  ordem: novaOrdemPorId.get(prevId.id),
                }
              : prevId,
          ),
        );
        showFlash("Sequência dos cursos atualizada.");
      } catch (error) {
        showFlash("Erro ao reordenar cursos.", "er");
      }
  };
  const carregarProblemas = async () => {
    setProblemasLoading(true);
    try {
      const data = await fetchSimuladoresConteudoErros();
      setProblemas(Array.isArray(data) ? data : []);
    } catch (error) {
      showFlash("Erro ao carregar problemas reportados.", "er");
    } finally {
      setProblemasLoading(false);
    }
  };
  const carregarInativos = async () => {
    setInativosLoading(true);
    try {
      const data = await fetchSimuladoresConteudoInativos();
      setInativos(data);
    } catch (error) {
      showFlash("Erro ao carregar itens inativos.", "er");
    } finally {
      setInativosLoading(false);
    }
  };
  const carregarCursosETodos = async () => {
    setCursosLoading(true);
    try {
      const data = await fetchSimuladorCursosPaginated({
        page: 1,
        limit: 500,
      });
      setTodosOsCursos(data.items || []);
      setCursosTotal(data.pagination?.total || 0);
      setCursosCarregados(true);
    } catch (error) {
      showFlash("Erro ao carregar cursos.", "er");
      setTodosOsCursos([]);
      setCursosCarregados(false);
    } finally {
      setCursosLoading(false);
    }
  };
  const carregarCategorias = async () => {
    try {
      const cats = await fetchSimuladorCategorias();
      const lista = Array.isArray(cats) ? cats : [];
      setLocalCategorias(lista);
      setConteudos((prev) => ({
        ...prev,
        categorias: lista,
      }));
      setCategoriasCarregadas(true);
    } catch (error) {
      showFlash("Erro ao carregar categorias.", "er");
    }
  };
  useEffect(() => {
    if ("cursos" === aba) {
      carregarCategorias();
      carregarCursosETodos();
    }
  }, [aba]);
  useEffect(() => {
    carregarProblemas();
  }, []);
  const catTotalPages = Math.max(1, Math.ceil(localCategorias.length / 4));
  const categoriasVisiveis = localCategorias.slice(
    4 * (catPage - 1),
    4 * catPage,
  );
  const termoInativos = filtroInativosTexto.trim().toLowerCase();
  const contemTermo = (...valores) => {
    if (!termoInativos) return true;
    return valores
      .map((valor) => String(valor || "").toLowerCase())
      .some((valor) => valor.includes(termoInativos));
  };
  const categoriasInativasFiltradas = (inativos.categorias || []).filter(
    (categoria) => contemTermo(categoria.nome, categoria.id),
  );
  const cursosInativosFiltrados = (inativos.cursos || []).filter((curso) =>
    contemTermo(curso.nome, curso.id, curso.cat_id, curso.sigla),
  );
  const modulosInativosFiltrados = (inativos.modulos || []).filter((modulo) =>
    contemTermo(modulo.nome, modulo.id, modulo.curso_id),
  );
  const aulasInativasFiltradas = (inativos.aulas || []).filter((aula) =>
    contemTermo(aula.titulo, aula.id, aula.modulo_id),
  );
  const cursosAtivosDisponiveis = ordenarCursos(todosOsCursos || []);
  const modulosAtivosDisponiveis = conteudos.modulos || [];
  const categoriasPorId = new Map(
    (conteudos.categorias || []).map((categoria) => [categoria.id, categoria]),
  );
  const cursosConhecidosPorId = new Map();
  [...(todosOsCursos || []), ...(inativos.cursos || [])].forEach((curso) => {
    if (
      null !== curso &&
      undefined !== curso &&
      curso.id &&
      !cursosConhecidosPorId.has(curso.id)
    ) {
      cursosConhecidosPorId.set(curso.id, curso);
    }
  });
  const modulosConhecidosPorId = new Map();
  [...(conteudos.modulos || []), ...(inativos.modulos || [])].forEach(
    (modulo) => {
      if (
        null !== modulo &&
        undefined !== modulo &&
        modulo.id &&
        !modulosConhecidosPorId.has(modulo.id)
      ) {
        modulosConhecidosPorId.set(modulo.id, modulo);
      }
    },
  );
  const rotuloCursoDestino = (curso) => {
    const categoria = categoriasPorId.get(curso?.cat_id);
    return null !== categoria && undefined !== categoria && categoria.nome
      ? "".concat(categoria.nome, " > ").concat(curso.nome)
      : curso?.nome || "Curso";
  };
  const rotuloModuloDestino = (modulo) => {
    const curso = cursosConhecidosPorId.get(modulo?.curso_id);
    const categoria = categoriasPorId.get(curso?.cat_id);
    return null !== categoria &&
      undefined !== categoria &&
      categoria.nome &&
      null !== curso &&
      undefined !== curso &&
      curso.nome
      ? ""
          .concat(categoria.nome, " > ")
          .concat(curso.nome, " > ")
          .concat(modulo.nome)
      : null !== curso && undefined !== curso && curso.nome
        ? "".concat(curso.nome, " > ").concat(modulo.nome)
        : modulo?.nome || "Modulo";
  };
  const exibirCategoriasInativas =
    "todos" === filtroInativosTipo || "categorias" === filtroInativosTipo;
  const exibirCursosInativos =
    "todos" === filtroInativosTipo || "cursos" === filtroInativosTipo;
  const exibirModulosInativos =
    "todos" === filtroInativosTipo || "modulos" === filtroInativosTipo;
  const exibirAulasInativas =
    "todos" === filtroInativosTipo || "aulas" === filtroInativosTipo;
  const totalInativosFiltrados =
    (exibirCategoriasInativas ? categoriasInativasFiltradas.length : 0) +
    (exibirCursosInativos ? cursosInativosFiltrados.length : 0) +
    (exibirModulosInativos ? modulosInativosFiltrados.length : 0) +
    (exibirAulasInativas ? aulasInativasFiltradas.length : 0);
  const [categoriaEmMovimento, setDmCatMoving] = useState(false);
  const moverCategoria = async (cat, delta) => {
    if (categoriaEmMovimento || !updateSimuladorCategoria) return;
    setDmCatMoving(true);
    try {
      await updateSimuladorCategoria(cat.id, {
        mover: delta,
      });
      const res = await api.get("".concat(BASE, "/categorias"));
      const list = Array.isArray(res && res.data && res.data.data)
        ? res.data.data
        : [];
      setLocalCategorias(list);
      setConteudos((resultado) => ({
        ...resultado,
        categorias: list,
      }));
      showFlash("Ordem salva.");
    } catch (err) {
      showFlash("Erro ao salvar a ordem.", "er");
    } finally {
      setDmCatMoving(false);
    }
  };
  if (cursoSelecionado) {
    const categoria =
      conteudos.categorias.find(
        (item) => item.id === cursoSelecionado.cat_id,
      ) || null;
    return (
      <AdminCourseManager
        curso={cursoSelecionado}
        categoria={categoria}
        dados={conteudos}
        setConteudos={setConteudos}
        updateConteudoCurso={updateConteudoCurso}
        addConteudoModulo={addConteudoModulo}
        updateConteudoModulo={updateConteudoModulo}
        removeConteudoModulo={removeConteudoModulo}
        addConteudoAula={addConteudoAula}
        updateConteudoAula={updateConteudoAula}
        removeConteudoAula={removeConteudoAula}
        removeConteudoCurso={removeConteudoCurso}
        showFlash={showFlash}
        onVoltar={() => {
          setCursoSelecionado(null);
          carregarCursosETodos();
        }}
      />
    );
  }
  return (
    <div
      style={{
        maxWidth: 980,
        margin: "0 auto",
        paddingBottom: 36,
      }}
    >
      {categoriaOpen && (
        <Modal
          titulo={"Nova categoria"}
          onClose={() => setCategoriaOpen(false)}
        >
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={categoriaForm.nome}
                onChange={(event) =>
                  setCategoriaForm((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div>
              <label style={LABEL}>{"Imagem de capa"}</label>
              <label
                style={{
                  display: "grid",
                  placeItems: "center",
                  border: "2px dashed #D6E0E5",
                  borderRadius: 12,
                  minHeight: 84,
                  cursor: "pointer",
                  color: "#64748B",
                  fontSize: 12,
                  fontWeight: 800,
                }}
              >
                {categoriaForm.capa ? "Trocar imagem" : "Escolher imagem"}
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{
                    display: "none",
                  }}
                  onChange={async (event) => {
                    const file = event.target.files?.[0];
                    if (!file) return;
                    const image = await fileToDataUrl(file);
                    setCategoriaForm((prev) => ({
                      ...prev,
                      capa: image,
                    }));
                  }}
                />
              </label>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setCategoriaOpen(false)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (categoriaForm.nome.trim()) {
                  try {
                    if (addConteudoCategoria) {
                      await addConteudoCategoria({
                        nome: categoriaForm.nome.trim(),
                        capa: categoriaForm.capa || null,
                      });
                    } else {
                      setConteudos((prev) => ({
                        ...prev,
                        categorias: [
                          ...prev.categorias,
                          {
                            id: uuid(),
                            nome: categoriaForm.nome.trim(),
                            capa: categoriaForm.capa || null,
                          },
                        ],
                      }));
                    }
                  } catch (error) {
                    showFlash("Erro ao criar categoria na API.", "er");
                    return;
                  }
                  setCategoriaOpen(false);
                  setCategoriaForm({
                    nome: "",
                    capa: null,
                  });
                  showFlash("Categoria criada.");
                } else showFlash("Nome da categoria obrigatorio.", "er");
              }}
              style={BTN_PRIMARY}
            >
              {"Criar categoria"}
            </button>
          </div>
        </Modal>
      )}
      {categoriaEditando && (
        <Modal
          titulo={"Editar categoria: ".concat(categoriaEditando.nome)}
          onClose={() => setCategoriaEditando(null)}
        >
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={categoriaEditando.nome}
                onChange={(event) =>
                  setCategoriaEditando((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div>
              <label style={LABEL}>{"Imagem de capa"}</label>
              <label
                style={{
                  display: "grid",
                  placeItems: "center",
                  border: "2px dashed #D6E0E5",
                  borderRadius: 12,
                  minHeight: 84,
                  cursor: "pointer",
                  color: "#64748B",
                  fontSize: 12,
                  fontWeight: 800,
                }}
              >
                {categoriaEditando.capa ? "Trocar imagem" : "Escolher imagem"}
                <input
                  type={"file"}
                  accept={"image/*"}
                  style={{
                    display: "none",
                  }}
                  onChange={async (event) => {
                    const file = event.target.files?.[0];
                    if (!file) return;
                    const image = await fileToDataUrl(file);
                    setCategoriaEditando((prev) => ({
                      ...prev,
                      capa: image,
                    }));
                  }}
                />
              </label>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button
              onClick={() =>
                setCategoriaEditando((prev) => ({
                  ...prev,
                  capa: null,
                }))
              }
              style={BTN_GHOST}
              type={"button"}
            >
              {"Remover imagem"}
            </button>
            <div
              style={{
                display: "flex",
                gap: 10,
              }}
            >
              <button
                onClick={() => setCategoriaEditando(null)}
                style={BTN_GHOST}
              >
                {"Cancelar"}
              </button>
              <button
                onClick={async () => {
                  if (categoriaEditando.nome.trim()) {
                    try {
                      if (updateSimuladorCategoria) {
                        await updateSimuladorCategoria(categoriaEditando.id, {
                          nome: categoriaEditando.nome.trim(),
                          capa: categoriaEditando.capa || null,
                        });
                      } else {
                        setConteudos((prev) => ({
                          ...prev,
                          categorias: prev.categorias.map((item) =>
                            item.id === categoriaEditando.id
                              ? {
                                  ...item,
                                  nome: categoriaEditando.nome.trim(),
                                  capa: categoriaEditando.capa || null,
                                }
                              : item,
                          ),
                        }));
                      }
                    } catch (error) {
                      showFlash("Erro ao atualizar categoria na API.", "er");
                      return;
                    }
                    setCategoriaEditando(null);
                    showFlash("Categoria atualizada.");
                  } else showFlash("Nome da categoria obrigatorio.", "er");
                }}
                style={BTN_PRIMARY}
              >
                {"Salvar"}
              </button>
            </div>
          </div>
        </Modal>
      )}
      {cursoOpen && (
        <Modal titulo={"Novo curso"} onClose={() => setCursoOpen(false)}>
          <div
            style={{
              display: "grid",
              gap: 12,
            }}
          >
            <div>
              <label style={LABEL}>{"Nome"}</label>
              <input
                value={cursoForm.nome}
                onChange={(event) =>
                  setCursoForm((prev) => ({
                    ...prev,
                    nome: event.target.value,
                  }))
                }
                style={INPUT}
              />
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr",
                gap: 12,
              }}
            >
              <div>
                <label style={LABEL}>{"Categoria"}</label>
                <select
                  value={cursoForm.cat_id}
                  onChange={(event) =>
                    setCursoForm((prev) => ({
                      ...prev,
                      cat_id: event.target.value,
                    }))
                  }
                  style={INPUT}
                >
                  <option value={""}>{"Selecione"}</option>
                  {localCategorias.map((categoria) => (
                    <option value={categoria.id} key={categoria.id}>
                      {categoria.nome}
                    </option>
                  ))}
                </select>
              </div>
              {null}
            </div>
            <div>
              <label style={LABEL}>{"Descrição"}</label>
              <textarea
                value={cursoForm.descricao}
                onChange={(event) =>
                  setCursoForm((prev) => ({
                    ...prev,
                    descricao: event.target.value,
                  }))
                }
                style={{
                  ...INPUT,
                  minHeight: 90,
                  resize: "vertical",
                }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 10,
              marginTop: 16,
            }}
          >
            <button onClick={() => setCursoOpen(false)} style={BTN_GHOST}>
              {"Cancelar"}
            </button>
            <button
              onClick={async () => {
                if (!cursoForm.nome.trim() || !cursoForm.cat_id) {
                  showFlash("Nome e categoria são obrigatórios.", "er");
                  return;
                }
                const proximaOrdem =
                  (todosOsCursos || [])
                    .filter((item) => item.cat_id === cursoForm.cat_id)
                    .reduce(
                      (maior, item) => Math.max(maior, parseOrdemCurso(item)),
                      0,
                    ) + 1;
                try {
                  if (addConteudoCurso) {
                    await addConteudoCurso({
                      cat_id: cursoForm.cat_id,
                      nome: cursoForm.nome.trim(),
                      sigla: (cursoForm.sigla || cursoForm.nome.slice(0, 3))
                        .toUpperCase()
                        .slice(0, 4),
                      descricao: cursoForm.descricao.trim(),
                      capa: null,
                      ordem: proximaOrdem,
                    });
                  } else {
                    setConteudos((prev) => ({
                      ...prev,
                      cursos: [
                        ...prev.cursos,
                        {
                          id: uuid(),
                          cat_id: cursoForm.cat_id,
                          nome: cursoForm.nome.trim(),
                          sigla: (cursoForm.sigla || cursoForm.nome.slice(0, 3))
                            .toUpperCase()
                            .slice(0, 4),
                          descricao: cursoForm.descricao.trim(),
                          capa: null,
                          ordem: proximaOrdem,
                        },
                      ],
                    }));
                  }
                } catch (error) {
                  showFlash("Erro ao criar curso na API.", "er");
                  return;
                }
                setCursoOpen(false);
                setCursoForm({
                  nome: "",
                  sigla: "",
                  cat_id: "",
                  descricao: "",
                });
                if ("cursos" === aba) {
                  await carregarCursosETodos();
                }
                showFlash("Curso criado.");
              }}
              style={BTN_PRIMARY}
            >
              {"Criar curso"}
            </button>
          </div>
        </Modal>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          gap: 12,
          alignItems: "start",
          marginBottom: 14,
        }}
      >
        <div>
          <h1
            style={{
              margin: 0,
              color: "#FFF",
              fontSize: 26,
            }}
          >
            {"Simuladores"}
          </h1>
          <div
            style={{
              color: "rgba(255,255,255,.56)",
              fontSize: 12,
              marginTop: 4,
            }}
          >
            {"Gestão de trilhas, módulos, aulas e feedback dos alunos."}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            gap: 8,
            flexWrap: "wrap",
          }}
        >
          <button onClick={() => setCategoriaOpen(true)} style={BTN_SECONDARY}>
            {"Nova categoria"}
          </button>
          <button
            onClick={() => {
              if (conteudos.categorias.length) {
                setCursoOpen(true);
              } else {
                showFlash("Crie uma categoria antes do curso.", "er");
              }
            }}
            style={BTN_PRIMARY}
          >
            {"Novo curso"}
          </button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: 8,
          marginBottom: 16,
        }}
      >
        {[
          ["cursos", "Cursos"],
          ["inativos", "Inativos"],
          [
            "erros",
            "Problemas (".concat(
              problemas.filter((item) => !item.lido).length,
              ")",
            ),
          ],
        ].map((item) => {
          const [resultado, label] = item;
          return (
            <button
              onClick={() => {
                setAba(resultado);
                if ("inativos" === resultado) {
                  carregarInativos();
                }
              }}
              style={{
                ...BUTTON_RESET,
                background:
                  aba === resultado ? "#FFF" : "rgba(255,255,255,.08)",
                color: aba === resultado ? BRAND_DARK : "rgba(255,255,255,.78)",
                borderRadius: 999,
                padding: "8px 14px",
                fontSize: 12,
                fontWeight: 900,
              }}
              key={resultado}
            >
              {label}
            </button>
          );
        })}
      </div>
      {"erros" === aba && (
        <ErrorPanel
          erros={problemas}
          loading={problemasLoading}
          onMarcarLido={async (erroId) => {
            const atualizados = problemas.map((item) =>
              item.id === erroId
                ? {
                    ...item,
                    lido: true,
                  }
                : item,
            );
            setProblemas(atualizados);
            try {
              await saveSimuladoresConteudoErrors(atualizados);
              showFlash("Erro marcado como lido.");
            } catch (error) {
              showFlash("Não foi possível salvar. Tente novamente.", "er");
            }
          }}
          onRemover={async (erroId) => {
            const atualizados = problemas.filter((item) => item.id !== erroId);
            setProblemas(atualizados);
            try {
              await saveSimuladoresConteudoErrors(atualizados);
              showFlash("Erro removido.", "in");
            } catch (error) {
              showFlash("Não foi possível remover. Tente novamente.", "er");
            }
          }}
        />
      )}
      {"cursos" === aba && (
        <div
          style={{
            display: "grid",
            gap: 16,
          }}
        >
          <div
            style={{
              ...CARD,
              padding: 12,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 10,
            }}
          >
            <div
              style={{
                color: "#526273",
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              {cursosCarregados
                ? "".concat(cursosTotal, " curso(s) no total")
                : cursosLoading
                  ? "Carregando cursos..."
                  : ""}
            </div>
            {catTotalPages > 1 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <button
                  onClick={() =>
                    setCatPage((resultado) => Math.max(1, resultado - 1))
                  }
                  style={BTN_GHOST}
                  disabled={catPage <= 1}
                >
                  {"Anterior"}
                </button>
                <div
                  style={{
                    color: "#526273",
                    fontSize: 12,
                    fontWeight: 800,
                  }}
                >
                  {catPage}
                  {" / "}
                  {catTotalPages}
                </div>
                <button
                  onClick={() =>
                    setCatPage((resultado) =>
                      Math.min(catTotalPages, resultado + 1),
                    )
                  }
                  style={BTN_GHOST}
                  disabled={catPage >= catTotalPages}
                >
                  {"Próxima"}
                </button>
              </div>
            )}
          </div>
          {(cursosLoading || !categoriasCarregadas) && (
            <div
              style={{
                ...CARD,
                padding: 16,
                color: "#64748B",
                fontSize: 13,
              }}
            >
              {"Carregando..."}
            </div>
          )}
          {categoriasCarregadas && !localCategorias.length && (
            <div
              style={{
                ...CARD,
                padding: 18,
                color: "#64748B",
                fontSize: 13,
              }}
            >
              {"Nenhuma categoria cadastrada."}
            </div>
          )}
          {categoriasCarregadas &&
            categoriasVisiveis.map((categoria) => {
              const cursos = ordenarCursos(
                todosOsCursos.filter((item) => item.cat_id === categoria.id),
              );
              return (
                <div key={categoria.id}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      gap: 12,
                      alignItems: "center",
                      marginBottom: 10,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 10,
                      }}
                    >
                      <div
                        style={{
                          width: 42,
                          height: 42,
                          borderRadius: 12,
                          background: categoria.capa
                            ? "url(".concat(
                                sourceImage(categoria.capa),
                                ") center/cover",
                              )
                            : "rgba(255,255,255,.1)",
                          flexShrink: 0,
                        }}
                      />
                      <div>
                        <div
                          style={{
                            color: "#FFF",
                            fontSize: 15,
                            fontWeight: 900,
                          }}
                        >
                          {categoria.nome}
                        </div>
                        <div
                          style={{
                            color: "rgba(255,255,255,.52)",
                            fontSize: 11,
                          }}
                        >
                          {cursos.length}
                          {" curso(s)"}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 12,
                        alignItems: "center",
                      }}
                    >
                      <button
                        type={"button"}
                        aria-label={"Mover " + categoria.nome + " para cima"}
                        title={"Mover categoria para cima"}
                        disabled={
                          categoriaEmMovimento ||
                          localCategorias.findIndex(
                            (item) => item.id === categoria.id,
                          ) === 0
                        }
                        onClick={() => moverCategoria(categoria, -1)}
                        style={{
                          border: "1px solid #cbd5e1",
                          borderRadius: 8,
                          padding: "6px 10px",
                          background: "#fff",
                          color: "#0f4959",
                          fontWeight: 800,
                          cursor: categoriaEmMovimento ? "wait" : "pointer",
                        }}
                      >
                        {"↑"}
                      </button>
                      <button
                        type={"button"}
                        aria-label={"Mover " + categoria.nome + " para baixo"}
                        title={"Mover categoria para baixo"}
                        disabled={
                          categoriaEmMovimento ||
                          localCategorias.findIndex(
                            (item) => item.id === categoria.id,
                          ) ===
                            localCategorias.length - 1
                        }
                        onClick={() => moverCategoria(categoria, 1)}
                        style={{
                          border: "1px solid #cbd5e1",
                          borderRadius: 8,
                          padding: "6px 10px",
                          background: "#fff",
                          color: "#0f4959",
                          fontWeight: 800,
                          cursor: categoriaEmMovimento ? "wait" : "pointer",
                        }}
                      >
                        {"↓"}
                      </button>
                      <button
                        onClick={() => setCategoriaEditando(clone(categoria))}
                        style={{
                          ...BUTTON_RESET,
                          background: "transparent",
                          color: "rgba(255,255,255,.68)",
                          fontSize: 12,
                          fontWeight: 800,
                        }}
                      >
                        {"Editar"}
                      </button>
                      <button
                        onClick={async () => {
                          if (
                            window.confirm(
                              "Desativar a categoria ".concat(
                                categoria.nome,
                                " e seus cursos?",
                              ),
                            )
                          ) {
                            try {
                              if (removeConteudoCategoria) {
                                await removeConteudoCategoria(categoria.id);
                                setLocalCategorias((prev) =>
                                  prev.filter(
                                    (prevId) => prevId.id !== categoria.id,
                                  ),
                                );
                                setTodosOsCursos((prev) =>
                                  prev.filter(
                                    (prevCat_id) =>
                                      prevCat_id.cat_id !== categoria.id,
                                  ),
                                );
                              } else {
                                const cursosIds = todosOsCursos
                                  .filter(
                                    (item) => item.cat_id === categoria.id,
                                  )
                                  .map((item) => item.id);
                                const modulosIds = conteudos.modulos
                                  .filter((item) =>
                                    cursosIds.includes(item.curso_id),
                                  )
                                  .map((item) => item.id);
                                const aulasIds = conteudos.aulas
                                  .filter((item) =>
                                    modulosIds.includes(item.modulo_id),
                                  )
                                  .map((item) => item.id);
                                setConteudos((prev) => ({
                                  ...prev,
                                  categorias: prev.categorias.filter(
                                    (item) => item.id !== categoria.id,
                                  ),
                                  cursos: prev.cursos.filter(
                                    (item) => item.cat_id !== categoria.id,
                                  ),
                                  modulos: prev.modulos.filter(
                                    (item) =>
                                      !cursosIds.includes(item.curso_id),
                                  ),
                                  aulas: prev.aulas.filter(
                                    (item) =>
                                      !modulosIds.includes(item.modulo_id),
                                  ),
                                  progresso: Object.keys(
                                    prev.progresso || {},
                                  ).reduce((acc, studentKey) => {
                                    const currentProgress = {
                                      ...(prev.progresso[studentKey] || {}),
                                    };
                                    aulasIds.forEach(
                                      (aulaId) =>
                                        delete currentProgress[aulaId],
                                    );
                                    acc[studentKey] = currentProgress;
                                    return acc;
                                  }, {}),
                                }));
                              }
                            } catch (error) {
                              showFlash(
                                "Erro ao desativar categoria na API.",
                                "er",
                              );
                              return;
                            }
                            showFlash("Categoria desativada.", "in");
                          }
                        }}
                        style={{
                          ...BUTTON_RESET,
                          background: "transparent",
                          color: "rgba(255,255,255,.48)",
                          fontSize: 12,
                          fontWeight: 800,
                        }}
                      >
                        {"Desativar"}
                      </button>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gap: 10,
                    }}
                  >
                    {!cursos.length && (
                      <div
                        style={{
                          ...CARD,
                          padding: 16,
                          color: "#64748B",
                          fontSize: 13,
                        }}
                      >
                        {"Nenhum curso nesta categoria."}
                      </div>
                    )}
                    {cursos.map((curso) => {
                      const modulos = conteudos.modulos.filter(
                        (item) => item.curso_id === curso.id,
                      );
                      const aulas = modulos.flatMap((modulo) =>
                        conteudos.aulas.filter(
                          (item) => item.modulo_id === modulo.id,
                        ),
                      );
                      const modulosCount = Number.isFinite(
                        Number(curso.modulos_count),
                      )
                        ? Number(curso.modulos_count)
                        : modulos.length;
                      const aulasCount = Number.isFinite(
                        Number(curso.aulas_count),
                      )
                        ? Number(curso.aulas_count)
                        : aulas.length;
                      return (
                        <div
                          draggable={true}
                          onDragStart={(event) => {
                            setCursoDragId(curso.id);
                            event.dataTransfer.effectAllowed = "move";
                            event.dataTransfer.setData("text/plain", curso.id);
                          }}
                          onDragOver={(event) => {
                            event.preventDefault();
                            if (cursoDragOverId !== curso.id) {
                              setCursoDragOverId(curso.id);
                            }
                          }}
                          onDrop={async (event) => {
                            event.preventDefault();
                            const cursoOrigemId =
                              cursoDragId ||
                              event.dataTransfer.getData("text/plain");
                            setCursoDragId(null);
                            setCursoDragOverId(null);
                            await reordenarCursosCategoria(
                              categoria.id,
                              cursoOrigemId,
                              curso.id,
                              cursos,
                            );
                          }}
                          onDragEnd={() => {
                            setCursoDragId(null);
                            setCursoDragOverId(null);
                          }}
                          style={{
                            ...CARD,
                            overflow: "hidden",
                            opacity: cursoDragId === curso.id ? 0.55 : 1,
                            outline:
                              cursoDragOverId === curso.id &&
                              cursoDragId !== curso.id
                                ? "2px dashed #4FD1C5"
                                : "none",
                            cursor: "grab",
                          }}
                          key={curso.id}
                        >
                          <div
                            style={{
                              padding: 16,
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 12,
                              alignItems: "start",
                            }}
                          >
                            <div>
                              {null}
                              <div
                                style={{
                                  color: "#17212B",
                                  fontSize: 18,
                                  fontWeight: 900,
                                }}
                              >
                                {curso.nome}
                              </div>
                              {curso.descricao && (
                                <div
                                  style={{
                                    color: "#526273",
                                    fontSize: 12,
                                    marginTop: 6,
                                  }}
                                >
                                  {curso.descricao}
                                </div>
                              )}
                              <div
                                style={{
                                  color: "#94A3B8",
                                  fontSize: 11,
                                  marginTop: 8,
                                }}
                              >
                                {modulosCount}
                                {" modulo(s) - "}
                                {aulasCount}
                                {" aula(s)"}
                              </div>
                            </div>
                            <div
                              style={{
                                display: "flex",
                                gap: 8,
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                <button
                                  title={"Mover para cima"}
                                  disabled={0 === cursos.indexOf(curso)}
                                  onClick={async () => {
                                    const idx = cursos.indexOf(curso);
                                    if (!(idx <= 0)) {
                                      await reordenarCursosCategoria(
                                        categoria.id,
                                        curso.id,
                                        cursos[idx - 1].id,
                                        cursos,
                                      );
                                    }
                                  }}
                                  style={{
                                    ...BUTTON_RESET,
                                    width: 28,
                                    height: 24,
                                    display: "grid",
                                    placeItems: "center",
                                    borderRadius: 6,
                                    background: "rgba(255,255,255,.10)",
                                    color: "#FFF",
                                    fontSize: 12,
                                    opacity:
                                      0 === cursos.indexOf(curso) ? 0.3 : 1,
                                    cursor:
                                      0 === cursos.indexOf(curso)
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                >
                                  {"▲"}
                                </button>
                                <button
                                  title={"Mover para baixo"}
                                  disabled={
                                    cursos.indexOf(curso) === cursos.length - 1
                                  }
                                  onClick={async () => {
                                    const idx = cursos.indexOf(curso);
                                    if (!(idx >= cursos.length - 1)) {
                                      await reordenarCursosCategoria(
                                        categoria.id,
                                        curso.id,
                                        cursos[idx + 1].id,
                                        cursos,
                                      );
                                    }
                                  }}
                                  style={{
                                    ...BUTTON_RESET,
                                    width: 28,
                                    height: 24,
                                    display: "grid",
                                    placeItems: "center",
                                    borderRadius: 6,
                                    background: "rgba(255,255,255,.10)",
                                    color: "#FFF",
                                    fontSize: 12,
                                    opacity:
                                      cursos.indexOf(curso) ===
                                      cursos.length - 1
                                        ? 0.3
                                        : 1,
                                    cursor:
                                      cursos.indexOf(curso) ===
                                      cursos.length - 1
                                        ? "not-allowed"
                                        : "pointer",
                                  }}
                                >
                                  {"▼"}
                                </button>
                              </div>
                              <button
                                onClick={() => setCursoSelecionado(curso)}
                                style={BTN_PRIMARY}
                              >
                                {"Gerenciar"}
                              </button>
                              <button
                                onClick={async () => {
                                  if (
                                    window.confirm(
                                      "Desativar o curso ".concat(
                                        curso.nome,
                                        "?",
                                      ),
                                    )
                                  ) {
                                    try {
                                      if (removeConteudoCurso) {
                                        await removeConteudoCurso(curso.id);
                                        setTodosOsCursos((prev) =>
                                          prev.filter(
                                            (prevId) => prevId.id !== curso.id,
                                          ),
                                        );
                                        setCursosTotal((prev) =>
                                          Math.max(0, prev - 1),
                                        );
                                      } else {
                                        const modulosIds = conteudos.modulos
                                          .filter(
                                            (item) =>
                                              item.curso_id === curso.id,
                                          )
                                          .map((item) => item.id);
                                        const aulasIds = conteudos.aulas
                                          .filter((item) =>
                                            modulosIds.includes(item.modulo_id),
                                          )
                                          .map((item) => item.id);
                                        setConteudos((prev) => ({
                                          ...prev,
                                          cursos: prev.cursos.filter(
                                            (item) => item.id !== curso.id,
                                          ),
                                          modulos: prev.modulos.filter(
                                            (item) =>
                                              item.curso_id !== curso.id,
                                          ),
                                          aulas: prev.aulas.filter(
                                            (item) =>
                                              !modulosIds.includes(
                                                item.modulo_id,
                                              ),
                                          ),
                                          progresso: Object.keys(
                                            prev.progresso || {},
                                          ).reduce((acc, studentKey) => {
                                            const currentProgress = {
                                              ...(prev.progresso[studentKey] ||
                                                {}),
                                            };
                                            aulasIds.forEach(
                                              (aulaId) =>
                                                delete currentProgress[aulaId],
                                            );
                                            acc[studentKey] = currentProgress;
                                            return acc;
                                          }, {}),
                                        }));
                                      }
                                    } catch (error) {
                                      showFlash(
                                        "Erro ao desativar curso na API.",
                                        "er",
                                      );
                                      return;
                                    }
                                    showFlash("Curso desativado.", "in");
                                  }
                                }}
                                style={BTN_GHOST}
                              >
                                {"Desativar"}
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
        </div>
      )}
      {"inativos" === aba && (
        <div
          style={{
            display: "grid",
            gap: 16,
          }}
        >
          <div
            style={{
              ...CARD,
              padding: 16,
              display: "grid",
              gap: 12,
            }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "minmax(220px, 1fr) 220px",
                gap: 10,
              }}
            >
              <div>
                <label style={LABEL}>{"Buscar por nome ou ID"}</label>
                <input
                  value={filtroInativosTexto}
                  onChange={(event) =>
                    setFiltroInativosTexto(event.target.value)
                  }
                  placeholder={"Ex.: Matematica, curso-123, mod-..."}
                  style={INPUT}
                />
              </div>
              <div>
                <label style={LABEL}>{"Tipo"}</label>
                <select
                  value={filtroInativosTipo}
                  onChange={(event) =>
                    setFiltroInativosTipo(event.target.value)
                  }
                  style={INPUT}
                >
                  <option value={"todos"}>{"Todos"}</option>
                  <option value={"categorias"}>{"Categorias"}</option>
                  <option value={"cursos"}>{"Cursos"}</option>
                  <option value={"modulos"}>{"Modulos"}</option>
                  <option value={"aulas"}>{"Aulas"}</option>
                </select>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 10,
              }}
            >
              <div
                style={{
                  color: "#64748B",
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {totalInativosFiltrados}
                {" item(ns) encontrado(s)"}
              </div>
              <button onClick={carregarInativos} style={BTN_GHOST}>
                {"Recarregar"}
              </button>
            </div>
          </div>
          {inativosLoading && (
            <div
              style={{
                ...CARD,
                padding: 16,
                color: "#64748B",
                fontSize: 13,
              }}
            >
              {"Carregando itens inativos..."}
            </div>
          )}
          {!inativosLoading && 0 === totalInativosFiltrados && (
            <div
              style={{
                ...CARD,
                padding: 16,
                color: "#64748B",
                fontSize: 13,
              }}
            >
              {"Nenhum item inativo encontrado com os filtros aplicados."}
            </div>
          )}
          {!inativosLoading &&
            exibirCategoriasInativas &&
            !!categoriasInativasFiltradas.length && (
              <div
                style={{
                  ...CARD,
                  padding: 16,
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px",
                    color: "#17212B",
                  }}
                >
                  {"Categorias inativas"}
                </h3>
                <div
                  style={{
                    display: "grid",
                    gap: 8,
                  }}
                >
                  {categoriasInativasFiltradas.map((categoria) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        alignItems: "center",
                        padding: 10,
                        border: "1px solid #E2E8F0",
                        borderRadius: 10,
                      }}
                      key={categoria.id}
                    >
                      <div>
                        <div
                          style={{
                            fontWeight: 800,
                            color: "#17212B",
                          }}
                        >
                          {categoria.nome}
                        </div>
                        <div
                          style={{
                            fontSize: 11,
                            color: "#64748B",
                          }}
                        >
                          {"ID: "}
                          {categoria.id}
                        </div>
                      </div>
                      <button
                        onClick={async () => {
                          try {
                            await restoreSimuladorCategoria(categoria.id);
                            showFlash("Categoria restaurada.");
                            await carregarInativos();
                          } catch (error) {
                            showFlash("Erro ao restaurar categoria.", "er");
                          }
                        }}
                        style={BTN_PRIMARY}
                      >
                        {"Restaurar"}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          {!inativosLoading &&
            exibirCursosInativos &&
            !!cursosInativosFiltrados.length && (
              <div
                style={{
                  ...CARD,
                  padding: 16,
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px",
                    color: "#17212B",
                  }}
                >
                  {"Cursos inativos"}
                </h3>
                <div
                  style={{
                    display: "grid",
                    gap: 8,
                  }}
                >
                  {cursosInativosFiltrados.map((curso) => (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        gap: 12,
                        alignItems: "center",
                        padding: 10,
                        border: "1px solid #E2E8F0",
                        borderRadius: 10,
                      }}
                      key={curso.id}
                    >
                      <div>
                        <div
                          style={{
                            fontWeight: 800,
                            color: "#17212B",
                          }}
                        >
                          {curso.nome}
                        </div>
                        <div
                          style={{
                            fontSize: 11,
                            color: "#64748B",
                          }}
                        >
                          {"Categoria: "}
                          {curso.cat_id}
                          {" | ID: "}
                          {curso.id}
                        </div>
                      </div>
                      <button
                        onClick={async () => {
                          try {
                            await restoreConteudoCurso(curso.id);
                            showFlash("Curso restaurado.");
                            await carregarInativos();
                          } catch (error) {
                            showFlash("Erro ao restaurar curso.", "er");
                          }
                        }}
                        style={BTN_PRIMARY}
                      >
                        {"Restaurar"}
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          {!inativosLoading &&
            exibirModulosInativos &&
            !!modulosInativosFiltrados.length && (
              <div
                style={{
                  ...CARD,
                  padding: 16,
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px",
                    color: "#17212B",
                  }}
                >
                  {"Modulos inativos"}
                </h3>
                <div
                  style={{
                    display: "grid",
                    gap: 8,
                  }}
                >
                  {modulosInativosFiltrados.map((modulo) => {
                    return (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr auto",
                          gap: 12,
                          alignItems: "start",
                          padding: 10,
                          border: "1px solid #E2E8F0",
                          borderRadius: 10,
                        }}
                        key={modulo.id}
                      >
                        <div>
                          <div
                            style={{
                              fontWeight: 800,
                              color: "#17212B",
                            }}
                          >
                            {modulo.nome}
                          </div>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#64748B",
                            }}
                          >
                            {"Curso:"}{" "}
                            {cursosConhecidosPorId.get(modulo.curso_id)?.nome ||
                              modulo.curso_id}{" "}
                            {"| ID: "}
                            {modulo.id}
                          </div>
                          <div
                            style={{
                              marginTop: 8,
                              display: "grid",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                ...LABEL,
                                margin: 0,
                              }}
                            >
                              {"Mover para curso ativo"}
                            </label>
                            <select
                              value={destinoCursoPorModulo[modulo.id] || ""}
                              onChange={(event) =>
                                setDestinoCursoPorModulo((prev) => ({
                                  ...prev,
                                  [modulo.id]: event.target.value,
                                }))
                              }
                              style={{
                                ...INPUT,
                                minWidth: 260,
                              }}
                            >
                              <option value={""}>
                                {"Selecionar curso de destino"}
                              </option>
                              {cursosAtivosDisponiveis.map((cursoAtivo) => (
                                <option
                                  value={cursoAtivo.id}
                                  key={cursoAtivo.id}
                                >
                                  {rotuloCursoDestino(cursoAtivo)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gap: 8,
                          }}
                        >
                          <button
                            onClick={async () => {
                              try {
                                await restoreConteudoModulo(modulo.id);
                                showFlash("Modulo restaurado.");
                                await carregarInativos();
                              } catch (error) {
                                showFlash("Erro ao restaurar modulo.", "er");
                              }
                            }}
                            style={BTN_PRIMARY}
                          >
                            {"Restaurar"}
                          </button>
                          <button
                            onClick={async () => {
                              const cursoDestino =
                                destinoCursoPorModulo[modulo.id] || "";
                              if (cursoDestino)
                                try {
                                  await restoreConteudoModulo(modulo.id, {
                                    curso_id: cursoDestino,
                                  });
                                  showFlash("Modulo restaurado e movido.");
                                  await carregarInativos();
                                } catch (error) {
                                  showFlash(
                                    "Erro ao restaurar e mover modulo.",
                                    "er",
                                  );
                                }
                              else
                                showFlash(
                                  "Selecione um curso de destino.",
                                  "er",
                                );
                            }}
                            style={BTN_GHOST}
                          >
                            {"Restaurar e mover"}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          {!inativosLoading &&
            exibirAulasInativas &&
            !!aulasInativasFiltradas.length && (
              <div
                style={{
                  ...CARD,
                  padding: 16,
                }}
              >
                <h3
                  style={{
                    margin: "0 0 10px",
                    color: "#17212B",
                  }}
                >
                  {"Aulas inativas"}
                </h3>
                <div
                  style={{
                    display: "grid",
                    gap: 8,
                  }}
                >
                  {aulasInativasFiltradas.map((aula) => {
                    return (
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr auto",
                          gap: 12,
                          alignItems: "start",
                          padding: 10,
                          border: "1px solid #E2E8F0",
                          borderRadius: 10,
                        }}
                        key={aula.id}
                      >
                        <div>
                          <div
                            style={{
                              fontWeight: 800,
                              color: "#17212B",
                            }}
                          >
                            {aula.titulo}
                          </div>
                          <div
                            style={{
                              fontSize: 11,
                              color: "#64748B",
                            }}
                          >
                            {"Modulo:"}{" "}
                            {modulosConhecidosPorId.get(aula.modulo_id)?.nome ||
                              aula.modulo_id}{" "}
                            {"| ID: "}
                            {aula.id}
                          </div>
                          <div
                            style={{
                              marginTop: 8,
                              display: "grid",
                              gap: 4,
                            }}
                          >
                            <label
                              style={{
                                ...LABEL,
                                margin: 0,
                              }}
                            >
                              {"Mover para modulo ativo"}
                            </label>
                            <select
                              value={destinoModuloPorAula[aula.id] || ""}
                              onChange={(event) =>
                                setDestinoModuloPorAula((prev) => ({
                                  ...prev,
                                  [aula.id]: event.target.value,
                                }))
                              }
                              style={{
                                ...INPUT,
                                minWidth: 260,
                              }}
                            >
                              <option value={""}>
                                {"Selecionar modulo de destino"}
                              </option>
                              {modulosAtivosDisponiveis.map((moduloAtivo) => (
                                <option
                                  value={moduloAtivo.id}
                                  key={moduloAtivo.id}
                                >
                                  {rotuloModuloDestino(moduloAtivo)}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "grid",
                            gap: 8,
                          }}
                        >
                          <button
                            onClick={async () => {
                              try {
                                await restoreConteudoAula(aula.id);
                                showFlash("Aula restaurada.");
                                await carregarInativos();
                              } catch (error) {
                                showFlash("Erro ao restaurar aula.", "er");
                              }
                            }}
                            style={BTN_PRIMARY}
                          >
                            {"Restaurar"}
                          </button>
                          <button
                            onClick={async () => {
                              const moduloDestino =
                                destinoModuloPorAula[aula.id] || "";
                              if (moduloDestino)
                                try {
                                  await restoreConteudoAula(aula.id, {
                                    modulo_id: moduloDestino,
                                  });
                                  showFlash("Aula restaurada e movida.");
                                  await carregarInativos();
                                } catch (error) {
                                  showFlash(
                                    "Erro ao restaurar e mover aula.",
                                    "er",
                                  );
                                }
                              else
                                showFlash(
                                  "Selecione um modulo de destino.",
                                  "er",
                                );
                            }}
                            style={BTN_GHOST}
                          >
                            {"Restaurar e mover"}
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
        </div>
      )}
    </div>
  );
}
export { SimuladoresConteudoAdminModule };
